import { retrieveBukabantuanPublicAnnouncements } from '~/api/announcement';
import { initiateChatbot, retrieveChatbotsSession, chatbotsCloseConversationSession } from '~/api/mitra-bantuan';
import { getAllowlist } from '~/api/allowlist';

export const state = () => ({
  chatbotsSession: {},
});

export const getters = {
  getChatbotsSession(state) {
    return state.chatbotsSession;
  },
  isChatBotsSessionActive(state) {
    return state.chatbotsSession?.state === 'active' || false;
  },
  isChatBotsSessionInactive(state) {
    return state.chatbotsSession?.state === 'inactive' || false;
  },
  isChatBotsSessionRespondentAgent(state) {
    return state.chatbotsSession?.respondent === 'agent' || false;
  },
};

export const mutations = {
  setChatbotsSession(state, payload) {
    state.chatbotsSession = payload;
  },
};

export const actions = {
  async fetchMitraAnnouncement() {
    try {
      const result = await retrieveBukabantuanPublicAnnouncements(this.$axios, { platform: 'mitra' });
      if (result.meta.http_status !== 200) return [];

      return result.data;
    } catch (error) {
      console.error('[ERROR FETCH ANNOUNCEMENT]', error);
      return [];
    }
  },
  async initiateChatbot(_, payload) {
    try {
      const result = await initiateChatbot(this.$axios, payload);
      return result;
    } catch (error) {
      console.error('[ERROR INITIATE CHATBOT]', error);
      throw error;
    }
  },
  async checkMitraChatMessagingEnabled({ rootGetters }) {
    try {
      const neoToggles = rootGetters['neo/getNeoToggles'];

      // Use revamped chat for non-logged in users
      if (!rootGetters['auth/isUserLoggedIn']) {
        return neoToggles['mitra-chat-messaging-non-login-enabled'];
      }

      let isMitraChatMessagingEnabled = neoToggles['mitra-chat-messaging-enabled'];

      if (isMitraChatMessagingEnabled) {
        const response = await getAllowlist(this.$axios, 'mitra_buka_bantuan_revamp');
        isMitraChatMessagingEnabled = (
          [
            'allowed',
            'allowed_gpt_5_nano',
            'allowed_gemini_25_flash',
            'allowed_gemini_25_hybrid',
          ].includes(response?.data.value)
        ) || false;
      }

      return isMitraChatMessagingEnabled;
    } catch (error) {
      console.error('[ERROR CHECK MITRA CHAT MESSAGING ENABLED]', error);
      return false;
    }
  },
  async fetchChatbotsSession({ commit }) {
    try {
      const result = await retrieveChatbotsSession(this.$axios);
      if (result?.meta?.http_status !== 200) commit('setChatbotsSession', {});

      commit('setChatbotsSession', result?.data);
    } catch (error) {
      console.error('[ERROR FETCH CHATBOTS SESSION]', error);
      commit('setChatbotsSession', {});
    }
  },
  async chatbotsCloseConversationSession() {
    try {
      const result = await chatbotsCloseConversationSession(this.$axios);
      return result;
    } catch (error) {
      console.error('[ERROR CLOSE CONVERSATION SESSION]', error);
    }
  },
};
